import Grid from '@material-ui/core/Grid';
import { PortalButton } from 'src/components/Buttons';
import { mediaMaxWidth2 } from 'src/styles/layout';
import styled, { css } from 'styled-components';
import { white } from 'src/styles';

export const ActionMenuContainer = styled(Grid)`
  padding: 10px 20px;
  display: inline-flex;
  justify-content: space-between;
`;

export const ActionCookieContainer = styled(Grid)`
  padding: 10px 20px;
  background-color: ${white};
  margin-top: 2rem;
`;

export const MenuButtonStyles = css`
  text-align: center;
  display: flex;
  justify-content: center;

  ${mediaMaxWidth2.tabletSmall`
    display: inline-block;
    width: 100%;
    margin-bottom: .8em;
    margin-left: 0;

    &:last-child {
      margin-bottom: 0;
    }
 `}
`;

export const PortalMenuButton = styled(PortalButton)`
  ${MenuButtonStyles}
`;
